import type { SolutionItem } from "./SolutionFinder/types"

export const SOLUTION_ITEMS: Record<string, SolutionItem> = {
  counter: {
    type: "bundle",
    value: "COUNTER_BUNDLE",
    name: "Yoco Counter",
    priceSidescript: "+R49pm connectivity fee",
    priority: 1,
  },
  counterPrinter: {
    type: "bundle",
    value: "COUNTER_PRINTER_BUNDLE",
    name: "Yoco Counter + Printer",
    priceSidescript: "+R49pm connectivity fee",
    priority: 1,
  },
  counterPrinters: {
    type: "bundle",
    value: "COUNTER_PRINTERS_BUNDLE",
    name: "Yoco Counter + 2 Printers",
    priceSidescript: "+R49pm connectivity fee",
    priority: 1,
  },
  counterBarcode: {
    type: "bundle",
    value: "COUNTER_BARCODE_BUNDLE",
    name: "Yoco Counter + Barcode Scanner",
    priceSidescript: "+R49pm connectivity fee",
    priority: 1,
  },
  counterPrinterBarcode: {
    type: "bundle",
    value: "COUNTER_PRINTER_BARCODE_BUNDLE",
    name: "Yoco Counter + Printer + Barcode Scanner",
    priority: 1,
  },
  khumo: {
    type: "product",
    value: "NXGN6LITE",
    priceSidescript: "+R49pm connectivity fee",
    priority: 3,
  },
  khumoPrint: {
    type: "product",
    value: "NXGN92",
    priority: 2,
  },
  barcode: {
    type: "product",
    value: "BS_Y",
    priority: 5,
  },
  printer: {
    type: "product",
    value: "PRNTR_Y",
    priority: 4,
  },
  all_online: {
    type: "online",
    value: "all",
    name: "Online Payment",
    image:
      "https://a.storyblok.com/f/111633/220x220/38a70683cb/payment-gateways.svg",
    priority: 7,
  },
  gateway: {
    type: "online",
    value: "gateway",
    priority: 8,
  },
  tap_to_pay: {
    type: "online",
    value: "tap_to_pay",
    priority: 6,
  },
  payment_request: {
    type: "online",
    value: "payment_request",
    priority: 9,
  },
  invoices: {
    type: "online",
    value: "invoices",
    priority: 10,
  },
}
